import Api from '../../../services';

export const getStatistics = () => {
  return (dispatch) => {
    return Api.hostApi.reporting.getStatistics().then((response) => {
      dispatch({
        type: 'GET_STATISTICS',
        data: response,
      });
      return response;
    });
  };
};

export const getPayouts = (params) => {
  return (dispatch) => {
    return Api.hostApi.reporting.getPayouts(params).then((response) => {
      dispatch({
        type: 'GET_HOST_PAYOUTS',
        data: response,
      });
      return response;
    });
  };
};

export const getPayments = (params) => {
  return (dispatch) => {
    return Api.hostApi.reporting.getPayments(params).then((response) => {
      dispatch({
        type: 'GET_HOST_PAYMENTS',
        data: response,
      });
      return response;
    });
  };
};

export const getPaymentDetails = (paymentId) => {
  return (dispatch) => {
    return Api.hostApi.reporting.getPaymentDetails(paymentId).then((response) => {
      dispatch({
        type: 'GET_HOST_PAYMENT_DETAILS',
        data: response,
      });
      return response;
    });
  };
};
